const { CompressedTransport } = require('./transport-compression');
const { TcpRawTransport } = require('./transport-tcp-plaintext');
const { TcpTlsTransport } = require('./transport-tcp-tls');
const { TlsOnlyTransport } = require('./transport-tls');

module.exports.TcpRawTransport = TcpRawTransport;
module.exports.CompressedTransport = CompressedTransport;
module.exports.TlsOnlyTransport = TlsOnlyTransport;
module.exports.TcpTlsTransport = TcpTlsTransport;
